import styled from '@emotion/styled'

export default styled.h3`
  font-size: 1.5rem;
  font-weight: 600;
  letter-spacing: -0.01rem;
`
